import { useState } from 'react';
import axios from 'axios';

export const useModuleInfo = () => {
  const [showModuleInfoModal, setShowModuleInfoModal] = useState(false);
  const [selectedModuleData, setSelectedModuleData] = useState(null);
  const [showModuleQuiz, setShowModuleQuiz] = useState(false);
  const [moduleQuizQuestions, setModuleQuizQuestions] = useState([]);
  const [isLoadingModuleQuiz, setIsLoadingModuleQuiz] = useState(false);
  const [isLoadingModuleDetails, setIsLoadingModuleDetails] = useState(false);

  const [concepts, setConcepts] = useState([]);
  const [infoMessages, setInfoMessages] = useState([]);
  const [infoTitle, setInfoTitle] = useState('');

  const fetchModuleQuestions = async (moduleId) => {
    setIsLoadingModuleQuiz(true);    
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_module_questions`,
        { module_id: moduleId }
      );
      
      setModuleQuizQuestions(res.data.questions || []);
      setShowModuleQuiz(true);
      return { success: true };
    } catch (err) {
      console.error('Error getting module questions:', err);
      setShowModuleQuiz(false);
      return { success: false, error: err };
    } finally {
      setIsLoadingModuleQuiz(false);
    }
  };

  const fetchModuleDetails = async (moduleId) => {
    setIsLoadingModuleDetails(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_module_details`,
        { module_id: moduleId }
      );
      
      setSelectedModuleData(response.data);
      setShowModuleInfoModal(true);

      // Separate rows by detail_name
      const conceptRows = response.data.details?.filter(d => d.detail_name === 'Concept');
      setConcepts(conceptRows);

      const infoTitleRow = response.data.details?.find(d => d.detail_name === 'ModuleInfoTitle');
      setInfoTitle(infoTitleRow?.detail_title || '');

      const infoRows = response.data.details?.filter(d => d.detail_name === 'ModuleInfoText');
      setInfoMessages(infoRows);

      return { success: true };
    } catch (err) {
      console.error('Error fetching module details:', err);
      return { success: false, error: err };
    } finally {
      setIsLoadingModuleDetails(false);
    }
  };

  const handleModuleSelect = (moduleId) => {
    // Module details will be fetched after subtopic selection
    return moduleId;
  };

  const closeModuleInfoModal = () => {
    setShowModuleInfoModal(false);
    setSelectedModuleData(null);
  };

  const closeModuleQuiz = () => {
    setShowModuleQuiz(false);
    setModuleQuizQuestions([]);
  };

  return {
    showModuleInfoModal,
    selectedModuleData,
    showModuleQuiz,
    moduleQuizQuestions,
    concepts,
    infoMessages,
    infoTitle,
    isLoadingModuleQuiz,
    isLoadingModuleDetails,
    fetchModuleQuestions,
    fetchModuleDetails,
    handleModuleSelect,
    closeModuleInfoModal,
    closeModuleQuiz
  };
};